export default "__VITE_PUBLIC_ASSET__7097824f__"